import * as i0 from '@angular/core';
import { Pipe, Inject, Injectable, signal, inject } from '@angular/core';
import { PureAbility } from '@casl/ability';
import { Observable } from 'rxjs';

/**
 * @deprecated use AbilityService instead
 */
let AblePipe = /*#__PURE__*/(() => {
  class AblePipe {
    constructor(ability) {
      this._ability = ability;
    }
    transform(...args) {
      return this._ability.can(...args);
    }
  }
  AblePipe.ɵfac = function AblePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AblePipe)(i0.ɵɵdirectiveInject(PureAbility, 16));
  };
  AblePipe.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
    name: "able",
    type: AblePipe,
    pure: false
  });
  return AblePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @deprecated use AbilityService instead
 */
let AblePurePipe = /*#__PURE__*/(() => {
  class AblePurePipe {
    constructor(ability) {
      this._ability = ability;
    }
    transform(...args) {
      return new Observable(s => {
        const emit = () => s.next(this._ability.can(...args));
        emit();
        return this._ability.on('updated', emit);
      });
    }
  }
  AblePurePipe.ɵfac = function AblePurePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AblePurePipe)(i0.ɵɵdirectiveInject(PureAbility, 16));
  };
  AblePurePipe.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
    name: "ablePure",
    type: AblePurePipe,
    pure: true
  });
  return AblePurePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbilityService = /*#__PURE__*/(() => {
  class AbilityService {
    constructor(ability) {
      this.ability$ = new Observable(observer => {
        observer.next(ability);
        return ability.on('updated', () => observer.next(ability));
      });
    }
  }
  AbilityService.ɵfac = function AbilityService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AbilityService)(i0.ɵɵinject(PureAbility));
  };
  AbilityService.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
    token: AbilityService,
    factory: AbilityService.ɵfac,
    providedIn: 'root'
  });
  return AbilityService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AbilityServiceSignal = /*#__PURE__*/(() => {
  class AbilityServiceSignal {
    constructor() {
      this._rules = signal([]);
      this._ability = inject(PureAbility);
      this.can = (...args) => {
        this._rules(); // generate side effect for angular to track changes in this signal
        return this._ability.can(...args);
      };
      this.cannot = (...args) => {
        return !this.can(...args);
      };
      this._disposeAbilitySubscription = this._ability.on('updated', event => {
        this._rules.set(event.rules);
      });
    }
    ngOnDestroy() {
      this._disposeAbilitySubscription();
    }
    update(rules) {
      this._ability.update(rules);
    }
  }
  AbilityServiceSignal.ɵfac = function AbilityServiceSignal_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AbilityServiceSignal)();
  };
  AbilityServiceSignal.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
    token: AbilityServiceSignal,
    factory: AbilityServiceSignal.ɵfac,
    providedIn: 'root'
  });
  return AbilityServiceSignal;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { AbilityService, AbilityServiceSignal, AblePipe, AblePurePipe };
